import { inject, observer } from 'mobx-react';
import { ReactComponent as TrashIcon } from '../../svg/trash-alt.svg'
import React from 'react'

@inject('workAreaStore', 'errorStore', 'store') @observer
class Upload extends React.Component {

  constructor(props){
    super(props)
    this.state = {
      fileName: '',
      dragging: false,
      files: []
    }
  }

  handleDragIn(e){
    e.preventDefault()
    const { dataTransfer } = e
    if(dataTransfer.items && dataTransfer.items.length){
      this.setState({ dragging: true })
    }
  }

  handleDragOut(e){
    e.preventDefault()
    this.setState({ dragging: false })
  }

  async uploadFiles(types, items){
    if(!items){
      return null
    }
    await Promise.all(Object.keys(items).map(async key => {
      const file = items[key]
      const v = file.name.split('.')
      const t = v[v.length - 1]
      if(!t){
        return
      }
      const type = t.toLowerCase()
      if(!types.includes(type)){
        this.props.errorStore.setErrorMessage('Invalid file type', true)
        return
      }
      await this.props.upload(file)
    }))
    return items.length
  }

  async handleDrop(e, form = false){
    e.preventDefault()
    const { store } = this.props
    if(store.auth){
      const types = [
        'jpg',
        'jpeg',
        'png',
        'svg'
      ]
      let data
      if(!e.dataTransfer){
        data = e.target.files
      }else{
        data = e.dataTransfer.files
      }
      if(this.props.isBackground && data && data.length){
        const [file] = data
        const v = file.name.split('.')
        const t = v[v.length - 1]
        if(!t){
          return
        }
        const type = t.toLowerCase()
        if(types.includes(type)){
          await this.props.upload(file)
          this.setState({
            fileName: 'background image',
            dragging: false
          })
        }else{
          this.props.errorStore.setErrorMessage('Invalid file type', true)
        }
        return
      }
      const dataTypes = Object.keys(data).map(key => data[key].type)
      if(dataTypes.includes('text/html')){
        this.setState({
          dragging: false
        })
        this.props.errorStore.setErrorMessage('Invalid file type text/html', true)
        return
      }
      if(!form){
        if(data && data.length > 0){
          this.setState({ dragging: false })
          const len = await this.uploadFiles(types, data)
          if(!len){
            return
          }
          this.setState({ 
            fileName: len + ' files'
          })
        }else{
          this.setState({
            dragging: false
          })
        }
      }else{
        this.setState({ dragging: false })
        const len = await this.uploadFiles(types, data)
        if(!len){
          return
        }
        this.setState({
          fileName: len + ' files'
        })
      }
    }else{
      store.toggleUpgradeModal('register', true)
      this.setState({
        dragging: false
      })
    }
  }

  getText(){
    const { uploading, label } = this.props
    const { fileName } = this.state
    return !uploading && !fileName ? label : uploading && fileName ? 'Uploading...' : 'Uploaded ' + fileName
  }

  getUploadTypes(){
    const types = [
      '.jpg',
      '.png',
      '.svg'
    ]
    return (
      types.map((t, idx) => (
        <div className='upload__type' key={t + idx}>
          <span className='upload__type__label'>
            {
              t
            }
          </span>
        </div>
      ))
    )
  }

  render(){
    const { name, customStyle, existingImage, existingText, deleteExisting, customFiles, progress } = this.props
    const { dragging } = this.state
    const className = `upload-area upload ${dragging ? 'dragging' : ''}`
    return (
      <>
      {
      existingImage && existingText ? (
        <div className='existing-image'>
          <span className='existing-image__text'>
            {existingText}
            {deleteExisting ? (
              <div className='existing-image__delete' onClick={deleteExisting}>
                <TrashIcon />
              </div>
            )
            :
            undefined }
          </span>
          <img className='existing-image__content mt-2' src={existingImage} />
        </div>
      )
      : 
      undefined
      }
      <div 
        onDragOver={this.handleDragIn.bind(this)}
        onDragLeave={this.handleDragOut.bind(this)}
        onDrop={this.handleDrop.bind(this)}
        onDragEnd={this.handleDragOut}
        className={className}
        style={customStyle || {}}
      >
        {
          customFiles || dragging ? (
            undefined
          )
          :
          (
            <div className='upload__supported'>
              {this.getUploadTypes()}
            </div>
          )
        }
        {
          dragging ? (
            <span className='upload__indicator'>
              Drop the asset
            </span>
          )
          :
          (
            <>
              <span className='upload__label'>
                {this.getText()}
              </span>
              {
                progress ? (
                  <div className='upload__progress'>
                    <div 
                      className='upload__progress-bar progress-bar' 
                      aria-valuenow={progress} 
                      aria-valuemin="0" 
                      aria-valuemax="100" 
                      style={{
                        width: `${progress}%`
                      }}
                    />
                  </div>
                )
                :
                undefined
              }
              <input
                type='file' 
                className='upload-input' 
                name={name} 
                onChange={e => this.handleDrop(e, true)}
              />
            </>
          )
        }
      </div>
      </>
    )
  }

}

export default Upload